import React, { useState } from 'react';
import './App.css';
import Navbar from './Component/Navbar';
import Text from './Component/Text';
import Alert from './Component/Alert';
import About from './Component/About';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  const [mode,setMode]=useState('light');
  const [alert,setAlert]=useState(null);
  const showAlert=(message,type)=>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
      setAlert(null);
    },2000)
  }
  const toggleMode=()=>{
    if(mode==='light'){
      setMode('dark');
      document.body.style.backgroundColor='#1a1d20';
    }
    else{
      setMode('light');
      document.body.style.backgroundColor='#fff';
    }
  }
  return (
  <>
    <Router>
      <Navbar title="TextUtils" mode={mode} toggleMode={toggleMode} />
      <Alert alert={alert} />
      <div className="container my-3">
        <Routes>
          <Route
            path="/"
            element={<Text showAlert={showAlert} heading="Text Area" mode={mode} />}
          />
          <Route path="/about" element={<About mode={mode} />} />
        </Routes>
      </div>
    </Router>
  </>
  );
}

export default App;
